<template>
    <div class="row mb-3">
        <div class="col-12">
            <h4 class="mt-3 mb-3 text-center">Location</h4>
            <div id="myLocation" style="position:relative;width:100%;height:400px;"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'username',
        'latitude',
        'longitude'
    ],
    mounted() {
        // Add a global function for the callback from Bing Maps api
        window.OnLoadBingMapsApi = () => this.InitMap();

        // Add programmaticaly the external Bing maps api script
        var scriptTag = document.createElement("script");
        scriptTag.src = "https://www.bing.com/api/maps/mapcontrol?callback=OnLoadBingMapsApi";
        scriptTag.id = "mapscript";

        // Inject the dynamic script in the DOM
        document.head.appendChild(scriptTag);
    },
    methods: {
        InitMap: function() {

            var map = new Microsoft.Maps.Map('#myLocation', {
                credentials: 'AqIcF4fggoP_K86DOjH02wUC3Dbgw5QbhdCvyVKRsqjYwJhPnNBQcPx9hhTOgAfp',
                center: new Microsoft.Maps.Location(this.latitude, this.longitude),
                zoom: 11
            });

            var center = map.getCenter();
            var pin = new Microsoft.Maps.Pushpin(center, { title: this.username });

            //Add the pushpin to the map
            map.entities.push(pin);
        }
    }
};
</script>
